export const getPublicPartners = state => state.networkReducer.publicPartnerList
